'use strict';

import $ from 'jquery';
import enquire from 'enquire.js';
import doT from 'dot';
import ScrollMagic from 'scrollmagic';
// import 'scrollmagic-debug';
import {bp} from '../../../_scripts/_helper';

export default class ProductCategory {
  constructor() {

    if($('.shop').length > 0) {
      let $productList = $('.products-list');
      // Update the cart whenever user clicks on add to cart
      let ajaxCartURL = $productList.data('carturl'),
          cart = {}; // cart object

      cart.products = []; // initially the products in the cart object will be empty array

      if(typeof(Storage) !== "undefined") {
        if(localStorage.getItem("productsInCart") !== null) {
          cart.products = JSON.parse(localStorage.getItem("productsInCart"));
        }
      }

      let productsInCart = cart.products;

      // Function to calculate the cart quantity
      function updateCartQuantity(productsInCart) {
        let cartQuantity = 0;
        productsInCart.forEach(function(product) {
          cartQuantity += Number(product.prodQty)
        });

        $('.cart-menu .cart-items').text(`(${cartQuantity})`); // update the cart the return value
      }

      $('.shop').on('click', '.product__addtocartbtn', function() {
        // Use localStorage
        if(typeof(Storage) !== "undefined") {

          let prodId = $(this).data('prodid'),
          productsInCart = [];
          if (localStorage.getItem("productsInCart") !== null) {
            productsInCart = JSON.parse(localStorage.getItem("productsInCart"));
          }

          let findProductInCart = productsInCart.find(function(product) {
            return product.productId == prodId;
          });

          if(findProductInCart) {
            findProductInCart.prodQty = Number(findProductInCart.prodQty) + 1;
          } else {
            productsInCart.push({
              productId: prodId,
              prodQty: 1
            })
          }

          localStorage.productsInCart = JSON.stringify(productsInCart); // set local storage value
          updateCartQuantity(productsInCart);
          $('.mobile-cart-icon .cart-items').addClass('has-item'); // update the cart icon in mobile
        }

        $(this).next('div').find('.product__viewcartbtn').addClass('added');
      });

      // DOI Links for desktop
      $('.shop').on('click.doiExpand', '.product__doi .expand', function() {
        let $this = $(this);
        $this.toggleClass('is-visible');
        if($this.hasClass('is-visible')) {
          $this.next('.doi').slideDown(200);
        } else {
          $this.next('.doi').slideUp(200);
        }
      });


      // Read more button
      $('.shop').on('click.readMoreExpand', '.product__read-more', function(e) {
        let $this = $(this);
        $this.toggleClass('show-desc');
        if($this.hasClass('show-desc')) {
          $this.prev('.product__desc').slideDown(200);
          $this.html('show less <span class="icon icon-chevron-small-up"></span>');
        } else {
          $this.prev('.product__desc').slideUp(200);
          $this.html('Read More <span class="icon icon-chevron-small-down"></span>');
        }
      });


      enquire.register("screen and (min-width:"+bp.minDesktop+"px)", {
        match : function() {

          // Flying image to cart
          $('.shop').on('click.addToCartDsk', '.product__addtocartbtn', function() {
            let $this = $(this),
                $prod = $this.closest('.product'),
                $prodImage = $prod.find('.product__image img'),
                offset = $prodImage.offset(),
                cart = $('.cart-menu').offset();

            $prodImage.clone().addClass('product-clone').appendTo($prod.find('.product__image'));

            // Animate the cloned product
            // the 30 used in the calculation below is the padding of product offset
            $('.product-clone').animate({
              top: '-'+parseInt(offset.top - cart.top - 30) + 'px',
              left: (cart.left - offset.left + 30) + 'px',
              'height': '0px',
              'width': '0px'
            }, 800, function(){
              $(this).remove();
            });

          });

        },
        unmatch : function() {
          $('.product__addtocartbtn').off('click.addToCartDsk');
        }
      });


      enquire.register("screen and (max-width:"+(bp.minDesktop-1)+"px)", {
        match : function() {
          // Flying image to cart
          $('.shop').on('click.addToCartMbl', '.product__addtocartbtn', function() {
            let $this = $(this),
                $prod = $this.closest('.product'),
                $prodImage = $prod.find('.product__image img'),
                offset = $prodImage.offset(),
                cart = $('.mobile-cart-icon').offset();

            $prodImage.clone().addClass('product-clone').appendTo($prod.find('.product__image'));

            // animate the cloned product
            $('.product-clone').animate({
              top: '-'+parseInt(offset.top - cart.top) + 'px',
              left: (cart.left - offset.left + 20) + 'px',
              'height': '0px',
              'width': '0px'
            }, 800, function(){
              $(this).remove();
            });
          });
        },
        unmatch : function() {
          $('.product__addtocartbtn').off('click.addToCartMbl');
        }
      })


      // Ajax loading for products
      let ajaxCatProductsURL =  $productList.data('categoryurl'),
          catParams = {
            itemsRequested: 10,
            nextStart: 1,
            category: $productList.data('category'),
            search: $productList.data('searchTerm')
          };

      let addProducts = function addProducts() {
        $.ajax({
          url: ajaxCatProductsURL,
          method: 'POST',
          dataType: 'json',
          data: catParams,
          ifModified: true,
          success: function(result) {
            if(result != undefined) {
              $('.loader').show();
              processData(result);
            }
          },
          error: function(error) {
            console.log(error);
          }
        });
      };

      // function to process the returned json from backend
      function processData(result) {
        let catProductsTemplate =  doT.template($('#catProductsTemplate').html()),
        // get the cart template from cart page and pass it to dot
            products = result.products,
            list = [];

        products.forEach(function(product, i) {
          list[i] = {
            id: product.productId,
            name: product.productName,
            price: product.productPrice,
            image: product.productImage,
            author: product.authors,
            issn: product.issn,
            shortdesc: product.productShortDesc,
            longdesc: product.productLongDesc,
            awardLabels: product.awardWinningLabels,
            doiText: product.doiText,
            doi: product.dois
          };
        });

        // console.log(products);

        let resultproducts = catProductsTemplate(list);
        $('.products-list').append('<div class="dynamic-content" style="display: none;">'+resultproducts+'</div>').find('div.dynamic-content').fadeIn(1000); // update the cart summary with the new datas
        scene1.update(); // make sure the scene gets the new start position
        $(".loader").hide();
      };

      // call addProducts function on page load
      addProducts();

      // Using scroll magic to make ajax call to add products.
      // Init ScrollMagic
      var controller = new ScrollMagic.Controller();

      // build a scene
      var scene1 = new ScrollMagic.Scene({
        triggerElement: '.footer',
        triggerHook: "onEnter"
      })
      .addTo(controller)
      .on("enter", function (e) {
        catParams.nextStart += 10;
        addProducts();
      });
    }
  }
}
